<template>
    <div class="blog-home">
      
      <article class="about  active" data-page="about">
        <header>
          <h2 class="h2 article-title">Kede Books</h2>
      </header>
      <section class="about-text">
        <h3 class="h3 service-title">Hi ! Let's dive in 🌱 </h3>
          <!-- ToBeMod -->
          <!-- <p>
            I'm Creative Director and UI/UX Designer, working in web development and print media.
            I enjoy turning complex problems into simple, beautiful and intuitive designs.
          </p> -->

          <p>
            &nbsp; First, Thanks for visiting ! 🙏 Here, you can browse through the book list to get a glimpse of the essential contents.
          </p>

          <!-- <p>
            &nbsp; Let me introduce myself: I am a Product Manager, <b>result-driven</b> and product <b>value-oriented</b> 🧭. 
            With 10 years of proven experience in Data Analysis 💻 and Project Management 👷‍♂️, 
            I have a track record of shipping user-facing products from ideation to launch 🚀.
          </p>

          <p>
            &nbsp; I translate business needs 💰 into technical solutions 🧑‍💻 across various environments, 
            including banking, multinational corporations, and small businesses. 
            I specialize in turning core problems into functional ♻️, innovative ⭐️, and intuitive 🏄 solutions.
          </p> -->

          <p>
            &nbsp; As a tech enthusiast, I enjoy taking on challenges 💪 and crafting innovative solutions.
          </p>

          <li>
            &nbsp; &nbsp; ➡️ This is a <a style="display: inline;font-style: italic;"> Personal Book Blog</a> 🎙 from key Books and Authors. I hope you enjoy it 😍.
          </li>
          <li>
            &nbsp; &nbsp; ➡️ Take a look at <a style="display: inline;color: #ffdb70c9 ;font-style: italic;" href="https://app.kedemailer.com/app" target="_blank" rel="nofollow noopener noreferrer">WeisUp Kindle Viewer</a> 📱
            a Web App displaying contents from readings 📖.
          </li>
          <li>
            &nbsp; &nbsp; ➡️ To know more about me, visit <a style="display: inline;color: #ffdb70c9 ;font-style: italic;" href="https://app.kedemailer.com" target="_blank" rel="nofollow noopener noreferrer">K-Ed Personal Portfolio</a> ☕️
            for background and contact 👨‍🚀.
          </li>
        
          <br/>

          <p>
            &nbsp; Marhaba 🙏 Enjoy and Get in touch ! 😉
          </p>
          
          <!-- <p>
            I am currently working in a B2B start-up environment, focusing on Business Process Management topics in different sectors.
          </p> -->
          
          <!-- <p>
            My job is to build your website so that it is functional and user-friendly but at the same time attractive.
            Moreover, I add personal touch to your product and make sure that is eye-catching and easy to use. My aim is to bring
            across your message and identity in the most creative way. I created web design for many famous brand companies.
          </p> -->
          <!-- <p>
            This is a Book blog with key Takeaways from key Books and Authors.
            Browse through the book list to get essential contents in a glimpse.
          </p>
          <br/>
          <p>
            Good reading and keep up in touch !
          </p> -->
        </section>

        <section class="service">

          <h3 class="h3 service-title">On-AIR : <i>Book of the week</i></h3>
          <div style="text-align: center;">
            <!-- <iframe style="border-radius: 20px;border-color: #cea557;border-width: 5px; max-width: 100%;" width="360" height="240" 
            src="https://www.youtube.com/embed/Pj8OEeZZKgA?si=ib8sNTrP7CyHngPT" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
            <!-- <iframe width="100%" height="100" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1988791687&color=%23418685&auto_play=true&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe> -->
            <iframe width="100%" height="100" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1988231119&color=%23418685&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe>',
          </div> 
          <br/>        
          <p class="service-item-text" style="text-align: center;">
            📻 <b><i>Surely You're Joking, Mr. Feynman</i>, Richard Feynman</b> 🚀
          </p>
          
        </section>
      
      <!-- <iframe style="width: 90vw;height: 60vw;margin-top: 20px;" src="https://www.youtube.com/embed/lA0yCLRhr_w?si=yzHpYWfzza49uiSk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
    </article>
    </div>
  </template>
  
  <script>
  import books from '@/data/books'
  
  export default {
    name: 'BlogHomePage',
    data() {
      return {
        books
      }
    }
  }
  </script>
  
  <!-- // Basic Styling (you can move this to a separate CSS file) -->
  <style>
  .book-post {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    border-style: inset;
    margin-bottom: 20px;
  }
  
  .book-cover {
    max-width: 100px;
    height: auto;
    border-color: #ffc562;
    border-width: 2px;
    border-style: inset;
  }
  
  .author-image {
    width: 100px;
    height: auto;
    border-radius: 25%;
    border-color: #ffc562;
    border-width: 2px;
    border-style: inset;
  }
  
  .book-tags .tag {
    background-color: #f0f0f0;
    padding: 5px 10px;
    margin-right: 10px;
    border-radius: 15px;
  }
  </style>
  
  